<template>
   <div>
      <my-show-error
          v-model="dialog_show_error"
          :error="show_error_obj"
      ></my-show-error>


      <v-dialog v-model="show_cant_edit" max-width="600" persistent>
         <v-card class="pa-3 red--text" style="font-size: 13pt">
            <div>
               This grade cannot be edited due to the following issues:
            </div>


            <div class="mt-3" style="font-size: 12pt">
               {{ edit_error_msg }}
            </div>

            <div style="display:flex">
               <v-spacer/>
               <v-btn @click="$emit('close')" color="primary"
               >close
               </v-btn>

            </div>
         </v-card>
      </v-dialog>


      <v-dialog :value="edit_warning_msg!=null" max-width="600" persistent>
         <v-card class="pa-3 red--text" style="font-size: 13pt">
            <div>
               Warning
            </div>


            <div class="mt-3" style="font-size: 12pt">
               {{ edit_warning_msg }}
            </div>

            <div style="display:flex">
               <v-spacer/>
               <v-btn @click="edit_warning_msg=null" color="primary"
               >close
               </v-btn>

            </div>
         </v-card>
      </v-dialog>

      <v-dialog
          v-model="show_delete_file"
          max-width="420"
          persistent
      >
         <v-card>
            <v-card-title class="headline">Confirm Delete File?</v-card-title>

            <v-card-text>
               Are you sure you want to delete this file?
            </v-card-text>

            <v-card-actions>
               <v-btn color="red" text @click="delete_file()">Delete</v-btn>
               <v-spacer></v-spacer>
               <v-btn text @click="show_delete_file=false; file_to_del=null">Cancel</v-btn>
            </v-card-actions>
         </v-card>
      </v-dialog>





      <v-dialog v-model="showGrade" max-width="900px" attach="#main-page" >
         <view-grade
             v-if="showGrade"
             :grade_id="form.grade_id._id"
             @close-parent="showGrade=false"
         ></view-grade>
      </v-dialog>
















      <!--------------------------- main content ---------------------------------------------------------------------->
      <v-container>
         <v-stepper v-model="stepper_step" vertical>
            <!-------------step 1------------------------------------------------------>
            <v-stepper-step step="1" :editable="isEditMode">
               <!--<span v-if="form.sales_people[0].name === ''">Team Info</span>-->
               <!--<span v-else>Selected ISM: {{ form.sales_people[0].name }}</span>-->

               Team Info
            </v-stepper-step>

            <v-stepper-content step="1">
               <v-card>
                  <!--<v-card-title class="myheader" color="primary">Select ISM to Grade   </v-card-title>-->
                  <!--<v-card-text>-->

                  <div
                      v-if="loading_team"
                      style="position: absolute; display: flex; align-items: center; justify-content: center; width: 100%"
                  >

                     <v-progress-circular
                         indeterminate
                         color="accent"
                         size="100"
                     />
                  </div>
                  <v-form ref="form_1">
                     <v-container fluid grid-list-md page>
                        <v-layout wrap>
                           <v-flex xs12 sm8>
                              <v-autocomplete
                                  label="Dealership"
                                  :items="dealerships"
                                  item-value="_id"
                                  item-text="txt"
                                  @change="on_select_dealership_cu"
                                  v-model="form.dealership.id"
                                  :rules="[x=>isRequired(x, 'Dealership')]"
                                  :disabled="isEditMode"
                              />
                           </v-flex>
                           <v-flex grow></v-flex>





                           <v-flex xs12 sm6>
                              <v-autocomplete
                                  label="Sales Person/Coachee"
                                  :items="salesPeople"
                                  item-value="user_id"
                                  item-text="name"
                                  v-model="form.coachee.user_id"
                                  v-on:change="on_sp_change()"
                                  :rules="[x=>isRequired(x, 'Sales Person')]"
                                  :disabled="isEditMode"
                              />

                           </v-flex>

                           <v-flex md6 class="myforminput">
                              <v-text-field
                                  label="Email"
                                  v-model="form.coachee.email"
                                  :rules="[x=>isRequired(x, 'Sales Person'), checkEmail]"
                                  :disabled="isEditMode"
                              />
                           </v-flex>


                           <v-flex xs12 sm6>
                              <v-autocomplete
                                  label="Manager/Coach"
                                  :items="managers"
                                  item-value="user_id"
                                  item-text="name"
                                  v-model="form.coach.user_id"
                                  v-on:change="on_mgm_change()"
                                  :rules="[x=>isRequired(x, 'Manager')]"
                                  :disabled="true"
                              />
                           </v-flex>

                           <v-flex md6 class="myforminput">
                              <v-text-field
                                  label="Manager email"
                                  v-model="form.coach.email"
                                  :rules="[x=>isRequired(x, 'Manager'), checkEmail]"
                                  :disabled="true"
                              />
                           </v-flex>



                        </v-layout>
                     </v-container>
                  </v-form>
               </v-card>

               <v-layout row v-if="form_error_1">
                  <v-spacer></v-spacer>
                  <v-flex shrink class="pr-3 red--text"> {{ form_error_1 }}</v-flex>
               </v-layout>


               <v-layout v-if="!isEditMode">
                  <v-spacer></v-spacer>
                  <v-btn color="primary" @click="stepper_1">Continue</v-btn>
               </v-layout>
            </v-stepper-content>


            <!------------------------------------------step 2-------------------------------------------->
            <v-stepper-step step="2" :editable="isEditMode">Coach Up</v-stepper-step>
            <v-stepper-content step="2">
               <v-card>
                  <v-form ref="form_2">

                     <!--------------lead handling------------------------------------------------>
                     <!--<form-lead-info-->
                     <!--    :form="form"-->
                     <!--/>-->


                     <v-card class="pa-4" v-if="form.grade_id !=null">
                        <div style="display: flex; align-items: center" class="mb-2">
                           <div style="font-weight: bold; color: gray; font-size: large" >
                              Lead Info
                           </div>

                           <v-spacer/>
                           <!--<v-btn small color="primary">See Graded Lead</v-btn>-->
                        </div>


                        <div style="display: flex; align-items: center" class="mb-2">
                           <table>
                              <tr class="lead-info-header">
                                 <th>Date In</th>
                                 <th>Customer</th>
                                 <th>Vehicle</th>
                              </tr>
                              <tr class="lead-info-data">
                                 <td style="padding-right: 40px">
                                    {{form.grade_id.info_lead.lead_arrived_date}}
                                 </td>
                                 <td style="padding-right: 40px">
                                    {{form.grade_id.info_customer.name_first}} {{form.grade_id.info_customer.name_last}}
                                 </td>
                                 <td>
                                    {{form.grade_id.info_lead.wanted_vehicle}}
                                 </td>
                              </tr>
                           </table>

                           <v-spacer/>
                           <v-btn small color="primary" @click="showGrade=true">See Graded Lead</v-btn>
                        </div>



                        <v-layout>
                           <!--<v-spacer/>-->
                           <div>

                           </div>
                        </v-layout>
                     </v-card>



                     <v-card class="pa-4" v-if="form.manual_data">
                        <div style="display: flex; align-items: center" class="mb-2">
                           <div style="font-weight: bold; color: gray; font-size: large" >
                              Lead Info (optional)
                           </div>

                           <v-spacer/>
                           <!--<v-btn small color="primary">See Graded Lead</v-btn>-->
                        </div>


                        <div style="display: flex; align-items: center" class="mb-2 ">
                           <v-text-field
                               class="mr-2"
                               label="Customer"
                               v-model="form.manual_data.info_lead.customer"
                           />

                           <v-text-field
                               label="Vehicle"
                               v-model="form.manual_data.info_lead.vehicle"
                           />



                           <!--------------lead in crm date-------------------------->
                           <v-flex xs12 sm4 md4 class="">
                              <v-menu
                                  v-model="date_menu1"
                                  :close-on-content-click="false"
                                  :nudge-right="0"
                                  lazy
                                  transition="scale-transition"
                                  offset-y
                                  :nudge-bottom="picker_nudge"
                                  full-width
                                  max-width="290px"
                                  min-width="290px"
                              >
                                 <template v-slot:activator="{ on }">
                                    <v-text-field
                                        class="ml-2"
                                        v-model="form.manual_data.info_lead.date_in"
                                        label="Date In"
                                        hint="YYYY-MM-DD format"
                                        prepend-icon="event"
                                        v-on="on"
                                        readonly
                                    ></v-text-field>
                                 </template>
                                 <v-date-picker
                                     v-model="form.manual_data.info_lead.date_in"
                                     @input="date_menu1 = false"
                                     no-title
                                 ></v-date-picker>
                              </v-menu>

                           </v-flex>

                           <!--<v-btn-->
                           <!--    v-if="form.manual_data.info_lead.date_in != null"-->
                           <!--    icon small style="margin-left: -20px"-->
                           <!--    @click="on_clear_date"-->
                           <!--&gt;-->
                           <!--   <v-icon small color="grey">close</v-icon>-->
                           <!--</v-btn>-->





                        </div>



                        <v-layout>
                           <!--<v-spacer/>-->
                           <div>

                           </div>
                        </v-layout>
                     </v-card>


                     <!--------------main grading form----------------------------------------------------------------->

                     <form-curriculum
                         ref="form_curriculum"
                         :curriculum="curriculum"
                         :form="form"
                         :grade_score.sync="grade_score"
                         :grade_letter.sync = "grade_letter"
                         :display_grade="false"
                     />


                     <!--------------comment section------------------------------------------------------------------->
                     <v-layout wrap class=" mt-5">
                        <v-flex xs12>
                           <span class="myheader"> Comments</span>
                           <v-divider></v-divider>
                        </v-flex>

                        <!--<v-flex xs12 sm12 md12>-->
                        <!--   <v-textarea-->
                        <!--       label="Internal Comments"-->
                        <!--       v-model="form.comments_internal"-->
                        <!--       outline-->
                        <!--       auto-grow-->
                        <!--   >-->
                        <!--   </v-textarea>-->
                        <!--</v-flex>-->

                        <v-flex xs12 sm12 md12 >
                           <v-textarea
                               label="Coaching Comments"
                               auto-grow
                               outline
                               v-model="form.comments_external"
                               :rules="[x => !!x || 'Please provides comments']"
                           >
                           </v-textarea>
                        </v-flex>

                     </v-layout>
                  </v-form>

               </v-card>

               <v-layout md12 v-if="form_error_2" class="pb-0">
                  <v-flex grow></v-flex>
                  <v-flex shrink class="red--text">{{ form_error_2 }}</v-flex>
               </v-layout>

               <!--<v-layout v-if="!isEditMode">-->
               <!--   <v-btn color="primary" @click="stepper_step = 1">Go Back</v-btn>-->
               <!--   <v-spacer></v-spacer>-->
               <!--   <v-btn color="primary" :loading="submit_save_form" @click="save_form">Continue</v-btn>-->
               <!--</v-layout>-->


               <!--&lt;!&ndash; edit buttons &ndash;&gt;-->
               <!--<v-layout v-else>-->
               <!--   <v-spacer/>-->
               <!--   <v-btn color="primary" :loading="submit_save_form" @click="save_form">Save Changes</v-btn>-->
               <!--   <v-spacer/>-->
               <!--</v-layout>-->





               <v-layout class="mt-4">

                  <!--<v-btn color="primary" :loading="submit_save_form" @click="save_form">Save Changes</v-btn>-->
                  <v-btn color="primary" @click="stepper_step = 1">Go Back</v-btn>
                  <v-spacer></v-spacer>
                  <v-btn color="primary" :loading="submit_save_form || submit_email_users" @click="save_and_finish">
                     <template v-if="form && (form.emailed_users == null ||  form.emailed_users.date == null)">
                        Save and Finish
                     </template>
                     <template v-else>
                        Re-Send Email
                     </template>
                  </v-btn>
               </v-layout>











            </v-stepper-content>


            <!------------------------------------------step 3 file uploads-------------------------------------------->
            <!--<v-stepper-step step="3" :editable="isEditMode">Add Supporting Docs/Links</v-stepper-step>-->
            <!--<v-stepper-content step="3">-->


            <!--   <v-card>-->
            <!--      <v-layout wrap>-->
            <!--         &lt;!&ndash;<v-flex md12>&ndash;&gt;-->
            <!--         &lt;!&ndash;   <v-text-field&ndash;&gt;-->
            <!--         &lt;!&ndash;       v-model="screencast_url"&ndash;&gt;-->
            <!--         &lt;!&ndash;       label="Screencast URL"&ndash;&gt;-->
            <!--         &lt;!&ndash;   ></v-text-field>&ndash;&gt;-->
            <!--         &lt;!&ndash;</v-flex>&ndash;&gt;-->


            <!--         <v-flex md12-->
            <!--                 v-for="(value, i) in files"-->
            <!--                 :key="'file'+i"-->
            <!--         >-->
            <!--            <input type="file" ref="fileInputs" v-on:change="selectFile(i)" style="display:none"/>-->
            <!--            <v-text-field-->
            <!--                label="Select File To Upload"-->
            <!--                v-model="files[i].name"-->
            <!--                hint="select file"-->
            <!--                @click="$refs.fileInputs[i].click()"-->
            <!--                append-outer-icon="clear"-->
            <!--                @click:append-outer="files.splice(i, 1)"-->
            <!--            ></v-text-field>-->
            <!--         </v-flex>-->

            <!--         <v-flex xs8 sm10 md10></v-flex>-->
            <!--         <v-flex grow></v-flex>-->
            <!--         <v-flex shrink>-->
            <!--            Add another file?-->
            <!--            <v-icon v-on:click="files.push({file: null, name:''})">add</v-icon>-->
            <!--         </v-flex>-->


            <!--         &lt;!&ndash;-&#45;&#45; edit file &#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&ndash;&gt;-->
            <!--         <div v-if="isEditMode" class="pl-2 pr-2 pb-3">-->
            <!--            <div style="font-size: 12pt; font-weight: 600; padding-bottom: 0px">-->
            <!--               Previously uploaded files-->
            <!--            </div>-->
            <!--            <div md12-->
            <!--                 v-for="(value, i) in existing_files"-->
            <!--                 style="font-size: 12pt"-->
            <!--                 :key="'oldfile-'+ i"-->
            <!--            >-->
            <!--         <span v-if="value.filename !=null">-->
            <!--         {{ value.filename }}-->
            <!--         </span>-->
            <!--               <span v-else>-->
            <!--         Screenshot {{ i + 1 }}:-->
            <!--         </span>-->

            <!--               <v-btn icon small @click="download_file(value.file_id, value.filename)">-->
            <!--                  <v-icon color="primary">cloud_download</v-icon>-->
            <!--               </v-btn>-->

            <!--               &lt;!&ndash;<v-btn icon small @click="show_delete_file_prompt(value.file_id, i)">&ndash;&gt;-->
            <!--               <v-btn icon small @click="existing_files.splice(i, 1)">-->
            <!--                  <v-icon color="red">delete</v-icon>-->
            <!--               </v-btn>-->
            <!--            </div>-->
            <!--         </div>-->


            <!--      </v-layout>-->
            <!--      &lt;!&ndash;<v-card-actions>&ndash;&gt;-->
            <!--      &lt;!&ndash;<v-spacer></v-spacer>&ndash;&gt;-->
            <!--      &lt;!&ndash;<v-btn slot="append-outer" v-on:click="submitFile()">&ndash;&gt;-->
            <!--      &lt;!&ndash;Upload File&ndash;&gt;-->
            <!--      &lt;!&ndash;</v-btn>&ndash;&gt;-->
            <!--      &lt;!&ndash;</v-card-actions>&ndash;&gt;-->

            <!--   </v-card>-->

            <!--   <v-layout md12 v-if="form_error_3" class="pb-0">-->
            <!--      <v-flex grow></v-flex>-->
            <!--      <v-flex shrink class="red&#45;&#45;text">{{ form_error_3 }}</v-flex>-->
            <!--   </v-layout>-->

            <!--   <v-layout v-if="!isEditMode">-->
            <!--      <v-btn color="primary" @click="stepper_step = 2">Go Back</v-btn>-->
            <!--      <v-spacer></v-spacer>-->
            <!--      <v-btn color="primary" :loading="submit_upload_files" @click="upload_files">-->
            <!--         Upload Files and Continue-->
            <!--         &lt;!&ndash;<span v-if="saved_data.file_ids === null">Upload Files and Continue</span>&ndash;&gt;-->
            <!--         &lt;!&ndash;<span v-else>Upload Files and Continue</span>&ndash;&gt;-->
            <!--      </v-btn>-->
            <!--   </v-layout>-->

            <!--   <v-layout v-else style="justify-content: center">-->
            <!--      <v-btn color="primary" :loading="submit_upload_files" @click="upload_files">-->
            <!--         Save Changes/Upload Files-->
            <!--      </v-btn>-->
            <!--   </v-layout>-->


            <!--</v-stepper-content>-->













            <!-----------------------------step 4 select recipients and email------------------------------------------>








            <!--<v-stepper-step step="4" :editable="isEditMode">Email Results and Finish</v-stepper-step>-->
            <!--<v-stepper-content step="4">-->

            <!--   <v-card>-->
            <!--      <v-layout wrap>-->
            <!--         <v-flex xs12 pb-2>-->
            <!--            This grade report for <span style="font-weight: bold;">{{ form.coachee.name }}</span>-->
            <!--            will be sent to-->
            <!--            <span v-for="item in form.sales_people" :key="item.email">-->
            <!--      {{ item.name }} ({{ item.email }}).-->
            <!--    </span> <br>-->
            <!--            The following individuals will also be copied on this email.-->
            <!--         </v-flex>-->

            <!--         <v-flex xs12>-->
            <!--            <span class="myheader">Client Users</span>-->
            <!--            <ul style="list-style-type:none">-->
            <!--               <li-->
            <!--                   v-for="(value, i) in managers"-->
            <!--                   :key="i"-->
            <!--               >-->
            <!--                  <v-checkbox class="mt-0"-->
            <!--                              :label="`${value.name} (${value.title}, ${value.email})`"-->
            <!--                              v-model="value.include"-->
            <!--                              hide-details-->
            <!--                  ></v-checkbox>-->
            <!--               </li>-->
            <!--            </ul>-->

            <!--            <div class="myheader pt-3">Agency Users</div>-->
            <!--            <ul style="list-style-type:none">-->
            <!--               <li-->
            <!--                   v-for="(value, i) in agency_admins"-->
            <!--                   :key="i"-->
            <!--               >-->
            <!--                  <v-checkbox class="mt-0"-->
            <!--                              :label="`${value.name} (${value.role}, ${value.email})`"-->
            <!--                              v-model="value.include"-->
            <!--                              hide-details-->
            <!--                              :readonly="canChangeEmailList"-->
            <!--                  ></v-checkbox>-->

            <!--               </li>-->
            <!--            </ul>-->

            <!--            <div xs12 v-if="form.comments_internal !== ''">-->
            <!--               <div class="myheader pt-3">Agency Users Who will be sent internal comments</div>-->
            <!--               <ul style="list-style-type:none">-->
            <!--                  <li-->
            <!--                      v-for="(value, i) in agency_admins_IC"-->
            <!--                      :key="i"-->
            <!--                  >-->
            <!--                     <v-checkbox class="mt-0"-->
            <!--                                 :label="`${value.name} (${value.role}, ${value.email})`"-->
            <!--                                 v-model="value.include"-->
            <!--                                 hide-details-->
            <!--                                 :readonly="canChangeEmailList"-->
            <!--                     ></v-checkbox>-->

            <!--                  </li>-->
            <!--               </ul>-->

            <!--            </div>-->
            <!--         </v-flex>-->

            <!--         <v-flex xs12 pb-4></v-flex>-->

            <!--      </v-layout>-->
            <!--   </v-card>-->


            <!--   <v-layout md12 v-if="form_error_4" class="pb-0">-->
            <!--      <v-flex grow></v-flex>-->
            <!--      <v-flex shrink class="red&#45;&#45;text">{{ form_error_4 }}</v-flex>-->
            <!--   </v-layout>-->


            <!--   <v-layout v-if="!isEditMode">-->
            <!--      &lt;!&ndash;<v-btn color="primary" @click="stepper_step = 3">Go Back</v-btn>&ndash;&gt;-->
            <!--      <v-spacer></v-spacer>-->
            <!--      <v-btn color="primary" :loading="submit_email_users" @click="send_emails2">Send Email and Finish-->
            <!--      </v-btn>-->
            <!--   </v-layout>-->


            <!--   <v-layout v-else>-->
            <!--      &lt;!&ndash;<v-btn color="primary" @click="stepper_step = 3">Go Back</v-btn>&ndash;&gt;-->
            <!--      <v-spacer></v-spacer>-->
            <!--      <v-btn color="primary" :loading="submit_email_users" @click="send_emails2">-->
            <!--         <template v-if="form && form.emailed_users === null">-->
            <!--            Send Email-->
            <!--         </template>-->
            <!--         <template v-else>-->
            <!--            Re-Send Email-->
            <!--         </template>-->
            <!--      </v-btn>-->
            <!--      <v-spacer></v-spacer>-->
            <!--   </v-layout>-->

            <!--</v-stepper-content>-->










         </v-stepper>
      </v-container><!--end of stepper-->


   </div>
</template>


<style scoped>
.myheader {
    font-size: large;
    font-weight: bold;
    color: grey;
}

.myquestion {
    font-size: medium;
    padding-right: 5px;
}

.myforminput {
    /*padding-top: 5px;*/
    /*padding-bottom: 5px;*/
    padding-left: 10px;
    padding-right: 10px;

}


.lead-info-header{
    font-weight: bold;
    text-align: left;
}

.lead-info-data{
    padding-left: 5px;
    padding-right: 5px;
}


</style>


<script>
import states_data from '@/data/states.js';
import validate from '@/mixins/validation';
import data_getters from '@/mixins/data_getters';
import curricula_common from './curricula_common.js';
import formLeadInfo from './formLeadInfo'
import formCurriculum from "@/views/Curricula/formCurriculum";
import viewGrade from "@/components/viewGrade";
import viewCoachup from "@/components/viewCoachup";

// import axios from 'axios';
import {DateTime} from 'luxon';
import _ from "lodash";
import axios from "axios";
//
// import _ from 'lodash';
// const axios2  = axios.create({
//    timeout: 1000*60*5, //5 mins
// });

// function findWithAttr(array, attr, value) {
//    for(var i = 0; i < array.length; i += 1) {
//       if(array[i][attr] === value) {
//          return i;
//       }
//    }
//    return -1;
// }

let clean_form = {
   answers: {}, //object indexed by the index position in this.questions. e.g. answers[0] is the answer to this.questions[0]


   coach: {},
   coachee:{},
   dealership:{},
   organization: {},

   emailed_users: null,


   // grade_id:{
   //    info_customer: {name_first: '', name_last: '', address: '', city: '', state: '', zip: '', phone: '', email: ''},
   //    info_lead: {
   //       wanted_vehicle: '',
   //       lead_source: '',
   //       lead_arrived_date: null,
   //       lead_arrived_time: null,
   //       email_response_date: null,
   //       email_response_time: null,
   //       phone_response_date: null,
   //       phone_response_time: null,
   //       no_email_received: false,
   //       no_call_received: false
   //    },
   // },

   grade_id: null,
   comments_external: '',
   date_grading_started: null,

};


export default {
   name: "GradeCoachUp",
   mixins: [data_getters, validate, curricula_common],
   components: {formLeadInfo, formCurriculum, viewGrade, viewCoachup},
   props: {
      coachup_id: {type: String, default: null},
      // dealer_id: {type: String, default: null},
      // org_id: {type: String, default: null},
      // salesperson_id: {type: String, default: null},
      // manager_id: {type: String, default: null},
   },
   data() {
      return {

         stepper_step: 1,
         form_error_1: null, //select user
         form_error_2: null, //main grading
         form_error_3: null, //upload files
         form_error_4: null, // email users

         loading_team: false,

         files: [{name: '', file: null}],
         managers: [],
         form: JSON.parse(JSON.stringify(clean_form)),
         clean_form: JSON.parse(JSON.stringify(clean_form)),

         agency_admins: [],  //people to copy on email
         agency_admins_IC: [], //people to email if internal comments are written

         screencast_url: '',
         grade_score: 0,
         grade_letter: '',

         states: states_data,
         form_error: '',

         // // date/time picker state variables (used to toggle display state)
         date_menu1: false,
         // date_menu2: false,
         // date_menu3: false,
         //
         // time_menu1: false,
         // time_menu2: false,
         // time_menu3: false,
         // lock_user: false,
         picker_nudge: 30,

         submit_save_form: false,
         submit_upload_files: false,
         submit_email_users: false,


         //dealership/sales person data
         dealerships: [],
         selected_dealer_id: null,
         selectedDealership: null,
         salesPeople: [],
         selectedSalesPerson: null,
         curriculum: null,
         showpass: false,

         showGrade: false,

         saved_data: {
            form_id: null, //objectid of the saved graded lead
            file_ids: null,
         },

         duplicate_lead_obj: {}, // used to save lead info to check for duplicates
         msg_duplicate_warning: null,
         lead_duplicates: [],


         //*** variables related to editing a grade ************
         existing_files: [], //used to hold current files when in edit mode
         edit_cu: null, //note this is only used to hold a copy of an existing coachup (form holds the working copy)

         show_cant_edit: false,
         edit_error_msg: null,
         edit_warning_msg: null,

         show_delete_file: false,
         file_to_del: null,//

      };
   },

   computed: {
      computedDateFormatted() {
         return this.formatDate(this.date)
      },

      canChangeEmailList() {
         return !(this.$auth.profile.acct_type === 'AGENCY' && this.$auth.profile.user_role === 'Admin');
      },

      isEditMode() {

         if (this.form._id == null){
            return false;
         }
         else{
            return true;
         }


      },

      editing_error() {
         return (this.isEditMode && this.edit_error_msg != null);
      }

   },

   watch: {
      editing_error(newVal) {
         this.show_cant_edit = newVal;
      }
   },


   methods: {

      on_clear_date(){

         console.log('test clear')
        // this.form.manual_data.info_lead.date_in = null;

         this.$set(this.form.manual_data.info_lead, 'date_in', null)
      },

      stepper_1() {
         if (!this.$refs.form_1.validate()) {
            this.form_error_1 = 'Please check highlighted fields.';
            return;
         }

         this.stepper_step = 2;
         this.form_error_1 = null;
         this.form.date_grading_started = new Date();
      },



      async get_agency_people() {


         // initiate calls for admin users, (wait for the calls to finish later)
         let admins_p = this.get_users_agency_by_client();//gets both Admins and AcctMangers
         // let admins_internal_p = this.get_users({acct_type: 'AGENCY', include_on_IC: true});



         //add admins/acctManagers
         this.agency_admins = [];
         this.agency_admins_IC = [];

         //TODO: this is slightly inefficient if agency_admins_IC resolves first
         let data1 = await admins_p;
         console.log('get_agency', data1)

         for (let i = 0; i < data1.length; i++) {
            this.agency_admins.push({
               name: data1[i].name, email: data1[i].email,
               include: data1[i].app_metadata.include_on_grades,
               role: data1[i].app_metadata.role,
               app_metadata: data1[i].app_metadata,
            })
         }

         // let data2 = await admins_internal_p;
         // for (let i = 0; i < data2.length; i++) {
         //    this.agency_admins_IC.push({
         //       name: data2[i].name, email: data2[i].email,
         //       include: data2[i].app_metadata.include_on_grades,
         //       role: data2[i].app_metadata.role,
         //       app_metadata: data1[i].app_metadata,
         //    })
         // }

      },



      async on_sp_change(){

         let ix = this.findWithAttr(this.salesPeople, 'user_id', this.form.coachee.user_id);
         this.form.coachee.name =  this.salesPeople[ix].name;
         this.form.coachee.email =  this.salesPeople[ix].email;



            // //select curriculum based on first salesperson selected
            // if (i===0){
            //    this.selectedSalesPerson = this.form.sales_people[i].user_id;
            //    await this.get_users_curriculum();
            //
            // }

      },


      async on_mgm_change(){

         let ix = this.findWithAttr(this.managers, 'user_id', this.form.coach.user_id);
         this.form.coach.email =  this.managers[ix].email;


      },







//**************************************************************************

      async save_and_finish(){
         await this.save_form();
         await this.send_emails2();
      },

      /**
       * updated send_email function where most of the logic of processing is moved to the backend
       * @return
       */
      async send_emails2(){


         this.submit_email_users = true;

         //TODO: Currently assumes only sending to first sales person in list
         let email_to = [];
         let email_cc = [];

         let emailed_users = [];


         // add sales people
         let user = this.form.coachee;

         email_to.push(user.email);
         emailed_users.push({
            email: user.email,
            name: user.name,
            user_id:  user.user_id,
            type: 'to'
         });


         user = this.form.coach;
         email_cc.push(user.email);
         emailed_users.push({
            email: user.email,
            name: user.name,
            user_id:  user.user_id,
            type: 'to'
         });


         //add managers
         let list = this.managers;
         for (let i=0; i<list.length; i++){
            if (list[i].app_metadata.include_on_coachup){
               email_cc.push(list[i].email);

               emailed_users.push({
                  email: list[i].email,
                  name: list[i].name,
                  user_id:  list[i].user_id,
                  type: 'to'
               });
            }

         }




         //******************get agency people***************************************
         //add the person grading
         email_cc.push(this.$auth.profile.email);

         //add admins/acctManagers

         list = this.agency_admins;
         for (let i=0; i<list.length; i++){
            if (list[i].app_metadata.include_on_coachup){
               email_cc.push(list[i].email);

               emailed_users.push({
                  email: list[i].email,
                  name: list[i].name,
                  user_id:  list[i].user_id,
                  type: 'cc'
               });
            }

         }


         // console.log('val', admins)
         console.log(email_to);
         console.log(email_cc);


         let link = process.env.VUE_APP_BASE_URL + `/view-coachup/${this.saved_data.form_id}`;

         let file_link = process.env.VUE_APP_BASE_URL + `/download-file/${this.saved_data.form_id}`;
         let file_links  =[];
         for (let i in this.saved_data.file_ids ){
            file_links.push(file_link+'?file_ix='+i)
         }

         let email_data = {
            to: email_to,
            cc: email_cc,
            sp_name: this.form.coachee.name,
            mgm_name: this.form.coach.name,
            comments_external: this.form.comments_external,
            link,
         };

         let email_body = {
            agency_id: this.$auth.profile.agency_id,
            email_data: email_data,
         };





         // //check if there are internal comments.  Email agency admins separately.
         // let ic_email_data = null;
         // if (this.form.comments_internal !== '' ){
         //
         //    let email_IC = []; //this.agency_admins_IC.map(x => x.email);
         //
         //    for (let i=0; i<this.agency_admins_IC.length; i++){
         //       if (this.agency_admins_IC[i].include)
         //          email_IC.push(this.agency_admins_IC[i].email)
         //    }
         //
         //
         //    ic_email_data = {
         //       to: email_IC,
         //       name: this.form.sales_people[0].name,
         //       vehicle: this.form.info_lead.wanted_vehicle,
         //       customer: this.form.info_cust.name_first + ' ' + this.form.info_cust.name_last,
         //       grade: this.grade_letter,
         //       link: link,
         //       comments_internal: this.form.comments_internal,
         //
         //    };
         //
         //    let url_IC = this.$baseUrlApi + '/sendEmailInternalComments';
         //    // await axios.post(url_IC, {email_data: email_data}, token);
         // }








         console.log('email data', email_data);
         try {
            // let token = await this.$auth.getAxiosHeader();
            let {token} = await this.base_user_request();
            let url = this.$baseUrlApi + '/finalizeCoachup';


            let coachup_update = {
               coachup_id: this.saved_data.form_id,
               emailed_users
            };


            let post_data = {
               agency_id: this.$auth.profile.agency_id,
               email_data: email_body,
               // IC_email_data: ic_email_data,
               coachup_update: coachup_update
            };

            await axios.post(url,post_data , token);


            //********clear out data*************************************

            //
            // this.form = JSON.parse(JSON.stringify(clean_form));
            // this.selectedSalesPerson = null;
            // this.curriculum = null;
            // this.stepper_step = 1;
            // this.files = [{name:'', file:null}];
            // this.saved_data = {form_id: null, file_ids: null};
            // this.screencast_url = '';
            //
            //
            // this.form_error_1 = null;
            // this.form_error_2 = null;
            // this.form_error_3 = null;
            // this.$refs.form_1.resetValidation();
            // this.$refs.form_2.resetValidation();



            this.$emit('close');


         }
         catch(err) {
            this.form_error_4  = this.show_error_details(err, 'send_emails()');
            // this.form_error_4 = "There was an issues sending email.  Please contact tech support."
         }

         this.submit_email_users = false;
      }, //send_emails2()



      async save_form(){

         if (!this.$refs.form_2.validate()){
            this.form_error_2 = 'Please check highlighted fields.';
            throw Error('form validation failed');
         }

         this.submit_save_form = true;

         const grades = ['A+', 'A', 'A-', 'B+', 'B', 'B-', 'C+', 'C', 'C-', 'D+', 'D', 'D-', 'F'];
         this.form_error = null;

         let dealer_ix = this.findWithAttr(this.dealerships, '_id', this.selected_dealer_id);
         let post_data = {
            // grade_score: this.grade_score, // raw score ism got 0 ... 100
            // grade_letter: this.grade_letter,
            // grade_letter_ix: grades.indexOf(this.grade_letter), //convert letter grade to number for easier analytics later

            // date_coaching_started: this.form.date_coaching_started,//todo need to update this

            dealership:{
               id: this.selected_dealer_id,
               name: this.dealerships[dealer_ix].name
            },
            organization: {
               id: this.dealerships[dealer_ix].org_id._id,
               name: this.dealerships[dealer_ix].org_id.name
            },

            coach: {
               name: this.form.coach.name,
               email: this.form.coach.email,
               user_id:  this.form.coach.user_id,
            },

            coachee: {
               name: this.form.coachee.name,
               email: this.form.coachee.email,
               user_id:  this.form.coachee.user_id
            },

            grade_id: this.form.grade_id,

            manual_data: this.form.manual_data,

            coachup_curriculum: {id: this.curriculum._id, name:this.curriculum.name},

            questions: [], //objects {question, answer, score, weight}
            comments_internal: this.form.comments_internal,
            comments_external:this.form.comments_external,
            agency_id: this.form.agency_id ? this.form.agency_id : this.$auth.profile.agency_id,
         };

         if (this.form.grade_id != null){
            post_data.manual_data = null;
         }



         if (this.saved_data.form_id != null){
            post_data._id = this.saved_data.form_id;
         }

         if (this.form._id === undefined && this.saved_data.form_id != null){
            post_data._id = this.saved_data.form_id;
         }

         // get data for curriculum questions
         let questions = this.curriculum.questions;
         for (let i=0; i<questions.length; i++){
            let ans_ix = this.form.answers[i];
            if (ans_ix !== undefined){
               post_data.questions.push({
                  question_id: questions[i].q_id._id,
                  question: questions[i].q_id.question,
                  answer: questions[i].q_id.answers[ans_ix].ans,
                  score: questions[i].q_id.answers[ans_ix].score,
                  weight: questions[i].weight
               })
            }
            else{
               this.form_error = "Please answer all curriculum questions.";
               break;
            }

         }


         console.log(post_data);

         //save to db
         if (!this.form_error){
            try {
               let token = await this.$auth.getAxiosHeader();
               let url = this.$baseUrlApi + '/updateCoachup';
               var res = await axios.post(url, post_data, token);
               this.saved_data.form_id = res.data; //returns id of saved doc


               if (!this.isEditMode){
                  this.stepper_step = 3;
               }


            }
            catch(err){
               this.form_error_2 = this.show_error_details(err, 'save_form()');
               // this.form_error_2 = 'There was an error saving.  Please contact tech support.'


            }
         }

         setTimeout(()=>{
            this.submit_save_form = false;
         }, 200)



      },//save_form()


      async on_select_dealership_cu(){
        this.selected_dealer_id = this.form.dealership.id; //needed as on_select_dealership() assumes this value is set
        await this.on_select_dealership();
        this.add_user_to_mgm_list();
        await this.update_curriculum();
      },


      add_user_to_mgm_list(){
         //if user's not in the list, then add them to managers
         let inList = false;
         for (let m of this.managers){
            if (m.user_id === this.$auth.profile.user_id){
               inList = true;
               break;
            }
         }

         if (!inList){
            this.managers.push(this.$auth.profile)
         }


         this.form.coach.user_id = this.$auth.profile.user_id;
         this.form.coach.email = this.$auth.profile.email;
         this.form.coach.name = this.$auth.profile.name;
      },


      async edit_new_coachup(){


         this.add_user_to_mgm_list();
         this.form = JSON.parse(JSON.stringify(clean_form));
         this.form.manual_data = {
            info_lead: {
               vehicle: null,
               customer: null,
               date_in: null,

            }
         }

      },


      //*******************functions for edit mode ***********************************************************
      // function to populate from with data from an existing coachup ***********
      async edit_existing_coachup(coachup_id){
         this.loading_team = true;

         console.log({coachup_id})

         let coachup = await this.get_coachups({_id: coachup_id});

         console.log({coachup})


         if (coachup == null){
            throw Error('Coachup not found')
         }
         //assumes length can't be greater than 1

         this.form = _.cloneDeep(this.clean_form);

         if (coachup.answer == null){
            coachup.answers = {}
         }


         this.saved_data.form_id = coachup._id;
         this.form = coachup;
         // this.existing_files =  coachup.additional_data.files;


         /*
            1. map stage 1 vars
            2. map main form vars (stage 2)
            3. figure out other shit that's different from graded leads
          */


         this.selected_dealer_id = coachup.dealership.id;
         await this.on_select_dealership();

         //if user's not in the list, then add them to managers
         // let inList = false;
         // for (let m of this.managers){
         //    if (m.user_id === this.$auth.profile.user_id){
         //       inList = true;
         //       break;
         //    }
         // }
         //
         // if (!inList){
         //    this.managers.push(this.$auth.profile)
         // }
         //
         //
         // this.form.coach.user_id = this.$auth.profile.user_id;
         // this.form.coach.email = this.$auth.profile.email;
         // this.form.coach.name = this.$auth.profile.name;


         this.add_user_to_mgm_list();


         this.loading_team = false;



         await this.update_curriculum(coachup);

         this.stepper_1(false);

      },



      async update_curriculum(coachup){



         let curriculum_id = _.get(this.selectedDealership, 'mgm_teacher.curricula.default', null);

         console.log('update_curriculum')
         await this.get_coachup_curriculum(curriculum_id);






         //****** recreate answers object for form *******
         let answers = {};
         let questions_map = {};//used to create hash map of questions by id

         for (let q of this.curriculum.questions){
            questions_map[q.q_id._id] = q.q_id;
         }


         let ix, q_id, ans, ans_list,q;

         if (coachup == null){
            coachup = this.form;
         }

         if (coachup.questions == null){
            return;
         }

         let questions_matched = 0;//used to count how many question in coachup match up with those in the curriculum
         for (let i=0; i<coachup.questions.length; i++){
            console.log('update_curriculum 2')
            ans = coachup.questions[i].answer
            q_id = coachup.questions[i].question_id;


            q = questions_map[q_id];

            if (q == null){
               this.edit_error_msg = `Couldn't find question ${i+1} in current version of the curriculum.  `;
               throw Error(`couldn't find graded question id=${q_id} in current version curriculum`);
            }
            else{
               questions_matched += 1;
            }

            ans_list = q.answers;

            ix = this.findWithAttr(ans_list, 'ans', ans);
            if (ix > -1){
               answers[i] = ix;
            }else{
               console.log(`Ans="${ans}" not found in question "${q.question}"`)
            }

         }
         this.form.answers = answers;
      },







   }, //methods
   //******************************************************************************************************************


   async created() {

      await this.get_dealers_local();
      await this.get_agency_people();

      console.log('debug')

      if (this.coachup_id != null) {
         this.edit_existing_coachup(this.coachup_id).catch(e=>{console.error(e)});
      }
      else{
         this.edit_new_coachup().catch(e=>{console.error(e)});
      }







      //
      // // get url query parameters
      // if (this.$route.query.dealer_id !== undefined) {
      //    this.selected_dealer_id = this.$route.query.dealer_id;
      //    await this.on_select_dealership();
      //    // await this.get_users_local();
      //
      //    if (this.$route.query.user_id !== undefined) {
      //       this.form.sales_people[0].user_id = this.$route.query.user_id;
      //       this.on_user_change(0);
      //    }
      // }

      // console.log('query params', this.$route.query);


   },


};
</script>
